import {useEvent} from 'Event/EventProvider'
import {Breadcrumb, WithBreadcrumbs} from 'lib/ui/BreadcrumbProvider'
import {useEventRoutes} from 'organization/Event/EventRoutes'
import React from 'react'

export type PageBreadcrumbProps = {
  children: JSX.Element
  parent?: Breadcrumb
  page: string
}

export default function PageBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()
  const {event} = useEvent()

  const parent = props.parent || {
    title: event.name,
    url: eventRoutes.root,
  }

  const breadcrumbs: Breadcrumb[] = [
    parent,
    {
      title: props.page,
    },
  ]

  return (
    <WithBreadcrumbs breadcrumbs={breadcrumbs}>
      {props.children}
    </WithBreadcrumbs>
  )
}

export function EventBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return <SectionBreadcrumbs {...props} title="Event" url={eventRoutes.root} />
}

export function DesignBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs {...props} title="Design" url={eventRoutes.dashboard} />
  )
}

export function MarketplaceBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Marketplace"
      url={eventRoutes.marketplace.root}
    />
  )
}

export function TicketsBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Ticket"
      url={eventRoutes.marketplace.tickets.root}
    />
  )
}

export function CustomPurchasePageBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Custom Purchase Page"
      url={eventRoutes.marketplace.custom_purchase_pages.root}
    />
  )
}

export function CheckInBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Check In"
      url={eventRoutes.password_create}
    />
  )
}

export function FeaturesBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Features"
      url={eventRoutes.forms.root}
    />
  )
}

export function AttendeesBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Attendees"
      url={eventRoutes.attendees}
    />
  )
}

export function ServicesBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Services"
      url={eventRoutes.services.root}
    />
  )
}

export function ZoomAreasBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Zoom Areas"
      url={eventRoutes.areas.root}
    />
  )
}

export function CommunicationBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Communication"
      url={eventRoutes.broadcasts}
    />
  )
}

export function CertificateBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Certificates"
      url={eventRoutes.certificates.root}
    />
  )
}

export function ProductionBreadcrumbs(props: PageBreadcrumbProps) {
  const eventRoutes = useEventRoutes()

  return (
    <SectionBreadcrumbs
      {...props}
      title="Production"
      url={eventRoutes.webhooks}
    />
  )
}

type SectionBreadcrumbProps = PageBreadcrumbProps & {
  title: string
  url: string
}

function SectionBreadcrumbs({
  title,
  url,
  children,
  parent,
  page,
}: SectionBreadcrumbProps) {
  const {event} = useEvent()
  const eventRoutes = useEventRoutes()

  const finalParent = parent || {
    title: event.name,
    url: eventRoutes.root,
  }

  const breadcrumbs: Breadcrumb[] = [
    finalParent,
    {title: title, url: url},
    {title: page},
  ]

  return <WithBreadcrumbs breadcrumbs={breadcrumbs}>{children}</WithBreadcrumbs>
}
